import React from "react";
import { Container, Typography } from "@mui/material";
import { useParams } from "react-router-dom";

export default function PedidoDetalhe() {
  const { id } = useParams();

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" mb={2}>
        Detalhe do Pedido #{id}
      </Typography>

      <Typography variant="body1" color="gray">
        Tela de detalhes do pedido — em construção.
      </Typography>
    </Container>
  );
}
